import {FUINavigationLinkAvailability} from "../navigation-link/navigation-link.model";

export class FUINavigationSearchResult{
    public breadcrumbs?: Array<string>;
    public href: string;
    public title: string;
    public availability: Promise<FUINavigationLinkAvailability>;

    constructor(result?: {breadcrumbs: string[], href: string, title: string, availability: Promise<FUINavigationLinkAvailability>}){
        this.breadcrumbs = result ? result.breadcrumbs : null;
        this.href = result ? result.href : null;
        this.title = result ? result.title : null;
        this.availability = result ? result.availability : null;
    }
}
